import { modalSelector } from "../forms-modal";

export const isVisibleFormModal = () => {
  const modal = document.querySelector(modalSelector);
  return !!(modal && modal.classList.contains("visible"));
};
